import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

//import { uploadUserPhoto } from "../../../../data-store/actions/atlete-actions";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import InputFileButton from "./InputFileButton1.2";
import { getPhotoFileToUpload } from "../../services/utils";
import * as fb from "../../firebase/firebasejs";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 10,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  inputLabel: {
    color: theme.palette.primary.main,
  },
}));

// ... (importaciones iguales)

export default function FieldManyPhotos(props) {
  const { fieldObject, register, errors } = props;
  const {
    fieldName,
    label,
    errorMessage,
    defaultValue,
    required,
    textSize,
    min,
    max,
    route,
  } = fieldObject;

  const { callbackPhoto } = props;
  const dispatch = useDispatch();
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const userID = useSelector((state) => state.atlete.userID);
  const classes = useStyles();

  const [urlPhotos, setUrlPhotos] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(null);
  const [uploadingPhotosProgress, setUploadingPhotosProgress] = useState(null);

  const callback = async (files) => {
    const rutaFoto = route ? route : "fotosVarias/" + Date.now();

    for (const file of files) {
      await getPhotoFileToUpload(file, 800, "foto").then((image) => {
        if (image) {
          const fotoSinJPG = file.name.replace(/\.[^/.]+$/, ""); // sin extensión
          const nombreRandom =
            fotoSinJPG + "_" + Math.floor(Math.random() * 100000 + 1) + ".JPG";

          const storageRef = fb.storage.ref();
          const uploadTask = storageRef
            .child(`${rutaFoto}/${nombreRandom}`)
            .put(image);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setUploadingPhotos(file.name);
              setUploadingPhotosProgress(progress);
            },
            (error) => {
              console.error("Upload failed:", error);
              setUploadingPhotos(null);
              setUploadingPhotosProgress(null);
            },
            () => {
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                setUploadingPhotos(null);
                setUploadingPhotosProgress(null);
                setUrlPhotos((prev) => [...prev, downloadURL]);
              });
            }
          );
        }
      });
    }
  };

  return (
    <Card className={classes.root}>
      <Typography
        variant={defaultValue || "h5"}
        component="h2"
        style={{ textAlign: "center" }}
        className={classes.inputLabel}
      >
        {label}
      </Typography>

      {urlPhotos.length > 0 &&
        urlPhotos.map((photo, index) => (
          <CardMedia
            key={index}
            component="img"
            alt={`foto-${index}`}
            height="auto"
            image={photo}
            title={`foto-${index}`}
            style={{ marginBottom: 10 }}
          />
        ))}

      <CardActions>
        <InputFileButton
          className={classes.inputLabel}
          type="image/*"
          multiple={true} // <- NUEVO
          callback={callback}
          uploadingPhotos={uploadingPhotos}
          uploadingPhotosProgress={uploadingPhotosProgress}
          text="Subir Fotos una o varias fotos"
        />
      </CardActions>

      {/* Solo guarda la última imagen como valor oculto. Para múltiples, esto debe cambiar según cómo guardes en tu sistema */}
      <TextField
        disabled={false}
        value={urlPhotos.join(",")} // puedes separar por comas o manejar diferente
        inputRef={register({ required: required })}
        name={fieldName}
        type="hidden"
      />
    </Card>
  );
}
